import { Select } from '@hub/shared'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface InputCompanyTypeProps {
  label: string
  disabled?: boolean
  readOnly?: boolean
  errorSpan?: boolean
  required: boolean
  externalError?: string
  errorIcon?: any
  id: string
  name: string
  leftLabel?: string
  rightLabel?: string
  externalIcon?: any
  value: string
  placeholder?: string
  backgroundColor?: string
  className: string
  onChange?: (value: any) => any
  onValidate?: (value: any) => any
  requiredOnLoad: boolean
}

export default ({
  label = '',
  disabled = false,
  readOnly = false,
  errorSpan = true,
  required = false,
  externalError,
  errorIcon = <i className="fa-regular fa-triangle-exclamation"></i>,
  id = '',
  name = '',
  leftLabel = '',
  rightLabel = '',
  externalIcon,
  value = '',
  placeholder = '',
  backgroundColor = '',
  className = '',
  onChange,
  onValidate,
  requiredOnLoad = false,
}: InputCompanyTypeProps) => {
  const { t } = useTranslation('inputRecordEmployment')
  const [validation, setValidation] = useState(false)
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    value: value,
    error: '',
  })
  const companyType = useMemo(
    () => [
      {
        text: 'EI (Empresário Individual)',
        value: 'EI (Empresário Individual)',
      },
      {
        text: 'Eireli (Empresa Individual de Responsabilidade Limitada)',
        value: 'Eireli (Empresa Individual de Responsabilidade Limitada)',
      },
      {
        text: 'EPP (Empresa de Pequeno Porte)',
        value: 'EPP (Empresa de Pequeno Porte)',
      },
      {
        text: 'Ltda. (Sociedade Empresária Limitada)',
        value: 'Ltda. (Sociedade Empresária Limitada)',
      },
      {
        text: 'ME (Micro Empresa)',
        value: 'ME (Micro Empresa)',
      },
      {
        text: 'MEI (Microempreendedor Individual)',
        value: 'MEI (Microempreendedor Individual)',
      },
      {
        text: 'S/A (Sociedade Anônima)',
        value: 'S/A (Sociedade Anônima)',
      },
      {
        text: 'S/S (Sociedade Simples)',
        value: 'S/S (Sociedade Simples)',
      },
      {
        text: 'SLU (Sociedade Limitada Unipessoal)',
        value: 'SLU (Sociedade Limitada Unipessoal)',
      },
    ],
    []
  )

  useEffect(() => {
    if (value !== state.value) {
      handleChange(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.value, value])

  const handleChange = useCallback(
    (value: string): void => {
      state.value = value
      if (externalError) {
        state.error = ''
      } else if (!!required && (!state.value || state.value.length < 1)) {
        state.error = t('required')
      } else {
        state.error = ''
      }

      setState({ ...state })
      if (onValidate && typeof onValidate === 'function') {
        onValidate(!state.error && !externalError)
      }
      if (onChange && typeof onChange === 'function') {
        onChange(state.value)
      }
    },
    [state, externalError, required, onChange, onValidate, t]
  )

  return (
    <Select
      label={label}
      placeholder={placeholder || '-'}
      value={value}
      className={className}
      name={name}
      errorIcon={errorIcon}
      id={id}
      loading={loading}
      onChange={handleChange}
      onValidate={(value: boolean) => setValidation(value)}
      disabled={disabled || loading}
      readOnly={readOnly}
      required={required}
      errorSpan={errorSpan}
      externalError={externalError ? externalError : state.error}
      leftLabel={leftLabel}
      rightLabel={rightLabel}
      externalIcon={externalIcon}
      backgroundColor={backgroundColor}
      requiredOnLoad={requiredOnLoad}
    >
      {companyType?.map(({ text, value }, index) => (
        <option key={index} value={value}>
          {text}
        </option>
      ))}
    </Select>
  )
}
